<template>
    <div>
        <b-form-group label-for="dias" class="mt-2">
            <b-form-group class="form-check form-check-inline">
                <b-form-checkbox v-model="peopleTrafficCompetition" :value="1" :disabled="disabled">
                    Transito de personas
                </b-form-checkbox>
            </b-form-group>
        </b-form-group>
    </div>
</template>

<script>
import {BFormGroup, BFormCheckbox} from 'bootstrap-vue'

export default {
    components: {
        BFormGroup,
        BFormCheckbox,
    },
    props: {
        peopleTrafficCompetition: {
            type: Number,
            default: 1
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            localPeopleTrafficCompetition: this.peopleTrafficCompetition,
        }
    },
    watch: {
        peopleTrafficCompetition(newVal) {
            this.localPeopleTrafficCompetition = newVal
            this.$emit('update', { people_traffic_competition: this.localPeopleTrafficCompetition })
        },
    },
}
</script>
